import React from "react";
import ReactDOM from "react-dom/client";
import "@fontsource/poppins/300.css";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import "@fontsource/poppins/800.css";
import "@fontsource/poppins/900.css";
import App from "./App";

// Stripe
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { appEnvironment } from "./config/appEnv";
import { stripePublishableKey } from "./config/billing";

if (!stripePublishableKey) {
    throw new Error(`Stripe publishable key is not defined for ${appEnvironment} environment.`);
}

console.log(`Stripe Mode: ${appEnvironment === "production" ? "LIVE" : "TEST"} (${appEnvironment})`);

export const stripePromise = loadStripe(stripePublishableKey);

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
    <Elements stripe={stripePromise}>
        <App />
    </Elements>
);
